var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 15.5V9.33333C28.3332 6.53307 28.3332 5.13293 27.7882 4.06338C27.3088 3.12257 26.5439 2.35766 25.6031 1.8783C24.5336 1.33333 23.1334 1.33333 20.3332 1.33333H9.6665C6.86624 1.33333 5.46611 1.33333 4.39655 1.8783C3.45574 2.35766 2.69084 3.12257 2.21147 4.06338C1.6665 5.13293 1.6665 6.53307 1.6665 9.33333V26.6667C1.6665 29.4669 1.6665 30.8671 2.21147 31.9366C2.69084 32.8774 3.45574 33.6423 4.39655 34.1217C5.46611 34.6667 6.86624 34.6667 9.6665 34.6667H14.9998M18.3332 16.3333H8.33317M11.6665 23H8.33317M21.6665 9.66666H8.33317M24.9998 33V23M19.9998 28H29.9998",
    stroke: "#6868FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/filePlus.0873d9e539e84885da675ef91d9a99a2.svg";
export { ForwardRef as ReactComponent };